import React from 'react';
import './GradientBlobBackground.css';

/**
 * Soft, slowly drifting blurred gradient blobs over a dark background plus a
 * faint grid overlay -- pure CSS (radial-gradient + @keyframes transforms),
 * no canvas/WebGL. Shared between the landing page and the sign-in page so
 * both read as one consistent design.
 */
export interface GradientBlobBackgroundProps {
  accent?: string;
}

const GradientBlobBackground: React.FC<GradientBlobBackgroundProps> = ({ accent = '#7c9cff' }) => {
  return (
    <div className="gradient-blob-background" aria-hidden="true">
      <div className="gradient-blob-layer">
        <div className="gradient-blob gradient-blob--one" style={{ background: `radial-gradient(circle at 30% 30%, ${accent}, transparent 70%)` }} />
        <div className="gradient-blob gradient-blob--two" />
        <div className="gradient-blob gradient-blob--three" />
      </div>
      <div className="gradient-blob-grid" />
    </div>
  );
};

export default GradientBlobBackground;
